import React from "react";
import { useNavigate } from 'react-router-dom';
import './App.css';
import { useEffect, useState, useRef } from 'react'
import { get } from '@aws-amplify/api';
import * as Auth from 'aws-amplify/auth';
import { useLocation } from 'react-router-dom';
import AppLayout from './components/AppLayout';

const ButterflyOptionsLegs = ({ signOut }) => {

  let email = useRef();
  const [forceRender, setForceRender] = useState(true);
  const location = useLocation();
  let optionsLegs = useRef(location.state?.optionsLegs);
  const navigate = useNavigate();
  let marketSentiment = useRef({});

  console.log("ButterflyOptionsLegs : optionsLegs = ", optionsLegs.current);

  const [error, setError] = useState('');
  const [displayMessage, setDisplayMessage] = useState('');
  const [formData, setFormData] = useState({});
  let [input, setInput] = useState("");
  let callStrikes = useRef([]);
  let putStrikes = useRef([]);
  let optionsLegsDetails = useRef([]);

  const getUserInfo = async () => {
    try {
      await Auth.fetchAuthSession();
      const user = await Auth.fetchUserAttributes();
      console.log("getUserInfo : email = " + JSON.stringify(user.email));
      email.current = await user.email;
      return "done";
    } catch (error) {
      console.log("Error in getUserInfo: ", error);
      return "error";
    }
  };

  // Market sentiment analysis functions
  function analyzeBearBull (optionsLegsDetails, lastSale) {
    console.log("Executing analyzeBearBull");
    if (!optionsLegsDetails || optionsLegsDetails.length === 0) {
      return {
        openInterest: "Neutral",
        pcr: "Neutral",
        iv: "Neutral",
        optionDeltaDistribution: "Neutral",
        skewnessStrikePrices: "Neutral",
        greeks: "Neutral",
        strikeProximity: "Neutral",
        bidAskSpread: "Neutral",
        overAll: "Neutral"
      };
    }

    let bearBullAnalysis = {};
    let openInterestAnalysis = "";
    let totalOpenInterestCalls = 0;
    let totalOpenInterestPuts = 0;
    let pcr = 0;
    let pcrAnalysis = "";

    for (let detInd = 0; detInd < optionsLegsDetails.length; detInd++) {
      if (optionsLegsDetails[detInd]) {
        if (optionsLegsDetails[detInd].type === "call") {
          if (optionsLegsDetails[detInd].openInterest) {
            totalOpenInterestCalls += optionsLegsDetails[detInd].openInterest;
          }
        } else {
          if (optionsLegsDetails[detInd].openInterest) {
            totalOpenInterestPuts += optionsLegsDetails[detInd].openInterest;
          }
        }
      }
    }

    if (totalOpenInterestCalls > totalOpenInterestPuts) {
      openInterestAnalysis = "Bullish";
    } else if (totalOpenInterestCalls < totalOpenInterestPuts) {
      openInterestAnalysis = "Bearish";
    } else {
      openInterestAnalysis = "Neutral";
    }

    if (totalOpenInterestCalls > 0 && totalOpenInterestPuts > 0) {
      pcr = totalOpenInterestPuts / totalOpenInterestCalls;
      if (pcr > 1) {
        pcrAnalysis = "Bearish";
      } else if (pcr < 1) {
        pcrAnalysis = "Bullish";
      } else {
        pcrAnalysis = "Neutral";
      }
    }

    let iv = analyzeIvBearBull(optionsLegsDetails);
    let optionDeltaDistribution = analyzeOptionDeltaDistribution(optionsLegsDetails);
    let skewnessStrikePrices = analyzeSkewnessStrikePrices(optionsLegsDetails);
    let greeks = analyzeGreeks(optionsLegsDetails);
    let strikeProximity = strikeProximityBearBull(optionsLegsDetails, lastSale);
    let bidAskSpread = analyzeBidAskSpread(optionsLegsDetails);

    bearBullAnalysis.openInterest = openInterestAnalysis;
    bearBullAnalysis.pcr = pcrAnalysis;
    bearBullAnalysis.iv = iv;
    bearBullAnalysis.optionDeltaDistribution = optionDeltaDistribution;
    bearBullAnalysis.skewnessStrikePrices = skewnessStrikePrices;
    bearBullAnalysis.greeks = greeks;
    bearBullAnalysis.strikeProximity = strikeProximity;
    bearBullAnalysis.bidAskSpread = bidAskSpread;
    bearBullAnalysis.overAll = overallSentimentBullBear(bearBullAnalysis);

    return bearBullAnalysis;
  }

  const overallSentimentBullBear = (bearBullAnalysis) => {
    const sentimentScores = {
      "Bullish": 1,
      "Bearish": -1,
      "Neutral": 0
    };

    let analysisWeights = {
      "greeksWeight": 2,
      "strikeProximityWeight": 1.5,
      "openInterestWeight": 1,
      "optionDeltaDistributionWeight": 1.5,
      "pcrWeight": 1,
      "ivWeight": 1.5,
      "skewnessStrikePrices": 1,
      "bidAskSpreadWeight": 1.25
    }

    let totalScore = 0;
    totalScore += sentimentScores[bearBullAnalysis.greeks] * analysisWeights.greeksWeight;
    totalScore += sentimentScores[bearBullAnalysis.strikeProximity] * analysisWeights.strikeProximityWeight;
    totalScore += sentimentScores[bearBullAnalysis.openInterest] * analysisWeights.openInterestWeight;
    totalScore += sentimentScores[bearBullAnalysis.optionDeltaDistribution] * analysisWeights.optionDeltaDistributionWeight;
    totalScore += sentimentScores[bearBullAnalysis.pcr] * analysisWeights.pcrWeight;
    totalScore += sentimentScores[bearBullAnalysis.iv] * analysisWeights.ivWeight;
    totalScore += sentimentScores[bearBullAnalysis.skewnessStrikePrices] * analysisWeights.skewnessStrikePrices;
    totalScore += sentimentScores[bearBullAnalysis.bidAskSpread] * analysisWeights.bidAskSpreadWeight;

    if (totalScore > 0) {
      return "Bullish";
    } else if (totalScore < 0) {
      return "Bearish";
    } else {
      return "Neutral";
    }
  };

  const analyzeBidAskSpread = (optionsLegsDetails) => {
    if (!Array.isArray(optionsLegsDetails) || optionsLegsDetails.length === 0) {
      return 'Neutral';
    }

    const calls = optionsLegsDetails.filter(option => option.type === 'call' && option.bid !== undefined && option.ask !== undefined);
    const puts = optionsLegsDetails.filter(option => option.type === 'put' && option.bid !== undefined && option.ask !== undefined);

    if (calls.length === 0 || puts.length === 0) {
      return 'Neutral';
    }

    const averageCallSpread = calls.reduce((sum, option) => sum + (option.ask - option.bid), 0) / calls.length;
    const averagePutSpread = puts.reduce((sum, option) => sum + (option.ask - option.bid), 0) / puts.length;

    if (averageCallSpread < averagePutSpread) {
      return 'Bullish';
    } else if (averagePutSpread < averageCallSpread) {
      return 'Bearish';
    } else {
      return 'Neutral';
    }
  };

  const strikeProximityBearBull = (optionsLegsDetails, underlyingPrice) => {
    if (!optionsLegsDetails || optionsLegsDetails.length === 0) return 'Neutral';

    let atmStrike = optionsLegsDetails.reduce((prev, curr) => {
      return Math.abs(curr.strike - underlyingPrice) < Math.abs(prev.strike - underlyingPrice) ? curr : prev;
    });

    const nearAtmCalls = optionsLegsDetails.filter(
      (option) => option.type === "call" && Math.abs(option.strike - atmStrike.strike) <= 5
    );

    const nearAtmPuts = optionsLegsDetails.filter(
      (option) => option.type === "put" && Math.abs(option.strike - atmStrike.strike) <= 5
    );

    const totalCallOpenInterest = nearAtmCalls.reduce((sum, option) => sum + option.openInterest, 0);
    const totalPutOpenInterest = nearAtmPuts.reduce((sum, option) => sum + option.openInterest, 0);

    if (totalCallOpenInterest > totalPutOpenInterest) {
      return "Bullish";
    } else if (totalPutOpenInterest > totalCallOpenInterest) {
      return "Bearish";
    } else {
      return "Neutral";
    }
  };

  const analyzeGreeks = (optionsLegsDetails) => {
    let totalCallDelta = 0;
    let totalPutDelta = 0;
    let totalCallGamma = 0;
    let totalPutGamma = 0;
    let totalCallVega = 0;
    let totalPutVega = 0;

    optionsLegsDetails.forEach((option) => {
      if (option.type === 'call') {
        if (option.delta) totalCallDelta += option.delta;
        if (option.gamma) totalCallGamma += option.gamma;
        if (option.vega) totalCallVega += option.vega;
      } else if (option.type === 'put') {
        if (option.delta) totalPutDelta += option.delta;
        if (option.gamma) totalPutGamma += option.gamma;
        if (option.vega) totalPutVega += option.vega;
      }
    });

    const isBullish = totalCallDelta > Math.abs(totalPutDelta) && totalCallGamma > totalPutGamma && totalCallVega > totalPutVega;
    const isBearish = totalPutDelta < -Math.abs(totalCallDelta) && totalPutGamma > totalCallGamma && totalPutVega > totalCallVega;

    if (isBullish) {
      return 'Bullish';
    } else if (isBearish) {
      return 'Bearish';
    } else {
      return 'Neutral';
    }
  };

  const analyzeSkewnessStrikePrices = (optionsLegsDetails) => {
    if (!Array.isArray(optionsLegsDetails) || optionsLegsDetails.length === 0) {
      return 'Neutral';
    }

    const calls = optionsLegsDetails.filter(option => option.type === 'call' && typeof option.impliedVolatility === 'number');
    const puts = optionsLegsDetails.filter(option => option.type === 'put' && typeof option.impliedVolatility === 'number');

    if (calls.length === 0 || puts.length === 0) return 'Neutral';

    const averageCallIV = calls.reduce((sum, option) => sum + option.impliedVolatility, 0) / calls.length;
    const averagePutIV = puts.reduce((sum, option) => sum + option.impliedVolatility, 0) / puts.length;

    const skew = averagePutIV - averageCallIV;

    if (skew > 0.05) {
      return 'Bearish';
    } else if (skew < -0.05) {
      return 'Bullish';
    } else {
      return 'Neutral';
    }
  };

  function analyzeOptionDeltaDistribution(optionsLegsDetails) {
    let totalCallDelta = 0;
    let totalPutDelta = 0;

    optionsLegsDetails.forEach((option) => {
      if (option.type === "call") {
        if (option.delta) totalCallDelta += option.delta;
      } else if (option.type === "put") {
        if (option.delta) totalPutDelta += option.delta;
      }
    });

    const netDelta = totalCallDelta + totalPutDelta;

    if (netDelta > 0.5) {
      return "Bullish";
    } else if (netDelta < -0.5) {
      return "Bearish";
    } else {
      return "Neutral";
    }
  }

  const analyzeIvBearBull = (options) => {
    let totalCallIV = 0;
    let totalPutIV = 0;
    let callCount = 0;
    let putCount = 0;

    options.forEach((option) => {
      if (option.type === "call") {
        if (option.impliedVolatility) {
          totalCallIV += option.impliedVolatility;
          callCount += 1;
        }
      } else if (option.type === "put") {
        if (option.impliedVolatility) {
          totalPutIV += option.impliedVolatility;
          putCount += 1;
        }
      }
    });

    const averageCallIV = callCount > 0 ? totalCallIV / callCount : 0;
    const averagePutIV = putCount > 0 ? totalPutIV / putCount : 0;

    if (averageCallIV < averagePutIV) {
      return "Bearish";
    } else if (averageCallIV > averagePutIV) {
      return "Bullish";
    } else {
      return "Neutral";
    }
  };

  useEffect(() => {
    if (input !== "") {
      navigate(input);
    }
  }, [input]);

  useEffect(() => {
    console.log("Executing useEffect");
    if (typeof (email.current) === 'undefined') {
      getUserInfo();
    }

    // Parse optionsLegs if it's a string
    if (typeof optionsLegs.current === 'string') {
      try {
        optionsLegs.current = JSON.parse(optionsLegs.current);
      } catch (e) {
        console.log("Error parsing optionsLegs:", e);
      }
    }

    // Set up form data from legs
    if (optionsLegs.current && optionsLegs.current.Legs) {
      const legs = optionsLegs.current.Legs;
      const newFormData = {};
      legs.forEach((leg, index) => {
        newFormData[`leg${index + 1}Strike`] = leg.strike;
        newFormData[`leg${index + 1}Quote`] = leg.quote;
        newFormData[`leg${index + 1}Delta`] = Math.abs(leg.actualDelta * 100).toFixed(0);
        newFormData[`leg${index + 1}Action`] = leg.action;
        newFormData[`leg${index + 1}Type`] = leg.type;
        newFormData[`leg${index + 1}Quantity`] = leg.quantity;
      });
      setFormData(newFormData);
    }

    // Extract strikes from details
    if (optionsLegs.current && optionsLegs.current.Details) {
      optionsLegsDetails.current = optionsLegs.current.Details;
      callStrikes.current = optionsLegsDetails.current
        .filter(option => option.type === "call")
        .map(option => option.strike);
      putStrikes.current = optionsLegsDetails.current
        .filter(option => option.type === "put")
        .map(option => option.strike);

      // Calculate market sentiment
      marketSentiment.current = analyzeBearBull(optionsLegs.current.Details, optionsLegs.current["Last Sale"]);
    }
  }, []);

  // Note: Removed auto-recalculation on initial load
  // Initial values from backend are used directly
  // Only recalculate when user changes strikes or quantities

  const handleSave = async () => {
    console.log("Executing handleSave");
    setDisplayMessage("Saving...");
    setError("");

    try {
      // Generate unique ID using current timestamp in milliseconds
      const id = Date.now().toString();

      // Build transaction data object
      const transactionData = {
        id: id,
        email: email.current,
        CommissionFee: optionsLegs.current['Commission Fee'] || '',
        Expiration: optionsLegs.current['Expiration'] || '',
        LastSale: optionsLegs.current['Last Sale'] || '',
        MaxGain: optionsLegs.current['Max Gain'] || '',
        MaxLoss: optionsLegs.current['Max Loss'] || '',
        LowerBreakeven: optionsLegs.current['Lower Breakeven'] || '',
        UpperBreakeven: optionsLegs.current['Upper Breakeven'] || '',
        NetAmount: optionsLegs.current['Net Amount'] || '',
        NetDelta: optionsLegs.current['Net Delta'] || '',
        NetGamma: optionsLegs.current['Net Gamma'] || '',
        NetTheta: optionsLegs.current['Net Theta'] || '',
        NetVega: optionsLegs.current['Net Vega'] || '',
        OpenCost: optionsLegs.current['Open Cost'] || '',
        Security: optionsLegs.current['Security'] || '',
        TargetDTE: optionsLegs.current['Target DTE'] || '',
        VIXChangePercent: optionsLegs.current['VIX Change %'] || '',
        VIXLastSale: optionsLegs.current['VIX Last Sale'] || '',
        openTradeDate: (() => {
          const now = new Date();
          const year = now.getFullYear();
          const month = String(now.getMonth() + 1).padStart(2, '0');
          const day = String(now.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        })(),
        closeTradeDate: '',
        closeCost: optionsLegs.current['Close Cost'] || '0.00',
        ProfitLossDollars: optionsLegs.current['Profit Loss Dollars'] || '0.00',
        ProfitLossPercent: optionsLegs.current['Profit Loss Percent'] || '0.00',
      };

      // Add Leg 1 data if exists
      if (optionsLegs.current.Legs && optionsLegs.current.Legs[0]) {
        let leg1 = optionsLegs.current.Legs[0];
        leg1.quote = (leg1.bid + leg1.ask)/2;
        transactionData.Leg1Action = leg1.action || '';
        transactionData.Leg1ActualDelta = leg1.actualDelta || '';
        transactionData.Leg1Ask = leg1.ask || '';
        transactionData.Leg1Bid = leg1.bid || '';
        transactionData.Leg1Cost = leg1.cost || '';
        transactionData.Leg1Gamma = leg1.gamma || '';
        transactionData.Leg1Label = leg1.label || '';
        transactionData.Leg1Quantity = leg1.quantity || '';
        transactionData.Leg1Quote = leg1.quote || '';
        transactionData.Leg1Strike = leg1.strike || '';
        transactionData.Leg1TargetDelta = leg1.targetDelta || '';
        transactionData.Leg1Theta = leg1.theta || '';
        transactionData.Leg1Type = leg1.type || '';
        transactionData.Leg1Vega = leg1.vega || '';
        transactionData.leg1OpenCost = leg1.cost || '';
        transactionData.leg1CloseCost = '';
      }

      // Add Leg 2 data if exists
      if (optionsLegs.current.Legs && optionsLegs.current.Legs[1]) {
        let leg2 = optionsLegs.current.Legs[1];
        leg2.quote = (leg2.bid + leg2.ask)/2;
        transactionData.Leg2Action = leg2.action || '';
        transactionData.Leg2ActualDelta = leg2.actualDelta || '';
        transactionData.Leg2Ask = leg2.ask || '';
        transactionData.Leg2Bid = leg2.bid || '';
        transactionData.Leg2Cost = leg2.cost || '';
        transactionData.Leg2Gamma = leg2.gamma || '';
        transactionData.Leg2Label = leg2.label || '';
        transactionData.Leg2Quantity = leg2.quantity || '';
        transactionData.Leg2Quote = leg2.quote || '';
        transactionData.Leg2Strike = leg2.strike || '';
        transactionData.Leg2TargetDelta = leg2.targetDelta || '';
        transactionData.Leg2Theta = leg2.theta || '';
        transactionData.Leg2Type = leg2.type || '';
        transactionData.Leg2Vega = leg2.vega || '';
        transactionData.leg2OpenCost = leg2.cost || '';
        transactionData.leg2CloseCost = '';
      }

      // Add Leg 3 data if exists
      if (optionsLegs.current.Legs && optionsLegs.current.Legs[2]) {
        let leg3 = optionsLegs.current.Legs[2];
        leg3.quote = (leg3.bid + leg3.ask)/2;
        transactionData.Leg3Action = leg3.action || '';
        transactionData.Leg3ActualDelta = leg3.actualDelta || '';
        transactionData.Leg3Ask = leg3.ask || '';
        transactionData.Leg3Bid = leg3.bid || '';
        transactionData.Leg3Cost = leg3.cost || '';
        transactionData.Leg3Gamma = leg3.gamma || '';
        transactionData.Leg3Label = leg3.label || '';
        transactionData.Leg3Quantity = leg3.quantity || '';
        transactionData.Leg3Quote = leg3.quote || '';
        transactionData.Leg3Strike = leg3.strike || '';
        transactionData.Leg3TargetDelta = leg3.targetDelta || '';
        transactionData.Leg3Theta = leg3.theta || '';
        transactionData.Leg3Type = leg3.type || '';
        transactionData.Leg3Vega = leg3.vega || '';
        transactionData.leg3OpenCost = leg3.cost || '';
        transactionData.leg3CloseCost = '';
      }

      console.log("Transaction data to save:", transactionData);

      // Prepare payload for API
      const payload = {
        email: email.current,
        transactionData: transactionData
      };

      const myAPI = "mktappapi";
      const path = '/storeButterflyTransaction/' + encodeURIComponent(JSON.stringify(payload));

      console.log("Calling API:", path);

      const response = await get({
        apiName: myAPI,
        path: path,
      }).response;

      const result = await response.body.json();
      console.log("Save response:", result);

      if (result.error) {
        setError("Error saving transaction: " + result.error);
        setDisplayMessage("");
      } else {
        setDisplayMessage("Transaction saved successfully!");
        setError("");
      }
    } catch (error) {
      console.log("Error in handleSave:", error);
      setError("Error saving transaction: " + error.message);
      setDisplayMessage("");
    }
  };

  const recalculateTotals = () => {
    if (!optionsLegs.current || !optionsLegs.current.Legs) return;

    let netAmount = 0;
    let netDelta = 0;
    let netGamma = 0;
    let netTheta = 0;
    let netVega = 0;
    let openCost = 0;
    let closeCost = 0;
    let totalContracts = 0;

    console.log("optionsLegs.current.Legs = ", optionsLegs.current.Legs);

    // Calculate net amount, Greeks, and open cost
    optionsLegs.current.Legs.forEach(leg => {
      // Net amount calculation
      let multiplier;
      if (leg.legNumber === 2) {
        multiplier = leg.action === "Buy" ? -2 : 2;
      } else {
        multiplier = leg.action === "Buy" ? -1 : 1;
      }
      netAmount += leg.quote * multiplier;

      // Greeks calculation
      const greekMultiplier = leg.action === "Buy" ? 1 : -1;
      netDelta += leg.actualDelta * leg.quantity * greekMultiplier;
      netGamma += (leg.gamma || 0) * leg.quantity * greekMultiplier;
      netTheta += (leg.theta || 0) * leg.quantity * greekMultiplier;
      netVega += (leg.vega || 0) * leg.quantity * greekMultiplier;

      // Open cost calculation (matches backend line 128)
      const costOpen = leg.action === "Buy" ? -leg.quote * leg.quantity * 100 : leg.quote * leg.quantity * 100;
      leg.cost = parseFloat(costOpen.toFixed(2));
      openCost += costOpen;

      totalContracts += leg.quantity;
    });

    // Commission calculation (matches backend lines 190-197)
    const openCommissionFee = optionsLegs.current.Legs.reduce((sum, leg) => sum + leg.quantity * 0.65, 0);

    if (openCost < 0) {
      openCost = openCost + (-1) * openCommissionFee;
    } else {
      openCost = openCost + openCommissionFee;
    }

    // Close cost calculation (matches backend lines 299-320)
    optionsLegs.current.Legs.forEach(leg => {
      const closeQuote = leg.bidAskMidPoint || leg.quote;
      if (leg.action === "Buy") {
        // Closing a buy = sell at bidAskMidPoint (receive money)
        closeCost += closeQuote * leg.quantity * 100;
      } else {
        // Closing a sell = buy at bidAskMidPoint (pay money)
        closeCost -= closeQuote * leg.quantity * 100;
      }
    });

    // Apply commission with same conditional logic as open cost
    const closeCommissionFee = totalContracts * 0.65;
    if (closeCost < 0) {
      closeCost = closeCost + (-1) * closeCommissionFee;
    } else {
      closeCost = closeCost + closeCommissionFee;
    }

    // Update calculated values
    optionsLegs.current['Net Amount'] = parseFloat(netAmount.toFixed(2));
    optionsLegs.current['Net Delta'] = parseFloat(netDelta.toFixed(4));
    optionsLegs.current['Net Gamma'] = parseFloat(netGamma.toFixed(4));
    optionsLegs.current['Net Theta'] = parseFloat(netTheta.toFixed(4));
    optionsLegs.current['Net Vega'] = parseFloat(netVega.toFixed(4));
    optionsLegs.current['Open Cost'] = parseFloat(openCost.toFixed(2));
    optionsLegs.current['Close Cost'] = parseFloat(closeCost.toFixed(2));
    optionsLegs.current['Commission Fee'] = parseFloat(openCommissionFee.toFixed(2));

    // Calculate P/L (matches backend lines 322-332)
    const profitLossDollars = closeCost + openCost;
    let profitLossPercent = 0;
    if (openCost !== 0) {
      profitLossPercent = (profitLossDollars / Math.abs(openCost)) * 100;
    }
    optionsLegs.current['Profit Loss Dollars'] = parseFloat(profitLossDollars.toFixed(2));
    optionsLegs.current['Profit Loss Percent'] = parseFloat(profitLossPercent.toFixed(2));

    // Max gain/loss calculation (matches backend lines 199-263)
    const sortedLegs = [...optionsLegs.current.Legs].sort((a, b) => a.strike - b.strike);
    if (sortedLegs.length >= 3 && sortedLegs[0].strike > 0 && sortedLegs[1].strike > 0 && sortedLegs[2].strike > 0) {
      const K1 = sortedLegs[0].strike; // Lower strike
      const K2 = sortedLegs[1].strike; // Middle strike
      const K3 = sortedLegs[2].strike; // Upper strike

      const wingQuantity = sortedLegs[0].quantity;

      // Calculate net debit per share
      const lowerCost = sortedLegs[0].quote;
      const middleCredit = sortedLegs[1].quote;
      const upperCost = sortedLegs[2].quote;

      const Debit = (lowerCost + upperCost) - (middleCredit * 2);

      // Calculate wings
      const LowerWing = K2 - K1;
      const UpperWing = K3 - K2;

      // Max gain calculation (backend line 231)
      const maxGainPerShare = (K2 - K1) - Debit;

      // Max loss calculation using tail payoffs (backend lines 235-240)
      const tailConstant = (2 * K2) - K1 - K3;
      const upperTailPayoff = tailConstant - Debit;
      const lowerTailPayoff = -Debit;
      const maxLossPerShare = Math.min(lowerTailPayoff, upperTailPayoff);

      // Total max gain/loss
      optionsLegs.current['Max Gain'] = parseFloat((maxGainPerShare * 100 * wingQuantity).toFixed(2));
      optionsLegs.current['Max Loss'] = parseFloat((maxLossPerShare * 100 * wingQuantity).toFixed(2));

      // Breakeven calculation (matches backend lines 269-290)
      const lowerStrike = sortedLegs[0].strike;
      const upperStrike = sortedLegs[2].strike;
      const netDebitPerShare = (lowerCost + upperCost) - (middleCredit * 2);

      optionsLegs.current['Lower Breakeven'] = parseFloat((lowerStrike + netDebitPerShare).toFixed(2));
      optionsLegs.current['Upper Breakeven'] = parseFloat((upperStrike - netDebitPerShare).toFixed(2));
    }

    setForceRender(prev => !prev);
  };

  const handleChange = (e) => {
    console.log("Executing handleChange");
    e.preventDefault();
    const { name, value } = e.target;
    console.log("handleChange : name = " + name + " value = " + value);

    // Update optionsLegs based on strike change
    if (name.includes("Strike")) {
      const legIndex = parseInt(name.replace("leg", "").replace("Strike", "")) - 1;
      const legType = optionsLegs.current.Legs[legIndex].type;

      // Find the option details for the new strike
      const newStrikeDetails = optionsLegsDetails.current.find(
        opt => opt.strike === parseFloat(value) && opt.type === legType
      );

      if (newStrikeDetails) {
        const action = optionsLegs.current.Legs[legIndex].action;
        const quote = action === "Buy" ? newStrikeDetails.ask : newStrikeDetails.bid;
        const bidAskMidPoint = newStrikeDetails.bidAskMidPoint;

        optionsLegs.current.Legs[legIndex].strike = parseFloat(value);
        optionsLegs.current.Legs[legIndex].actualDelta = newStrikeDetails.delta;
        optionsLegs.current.Legs[legIndex].quote = quote;
        optionsLegs.current.Legs[legIndex].bid = newStrikeDetails.bid;
        optionsLegs.current.Legs[legIndex].ask = newStrikeDetails.ask;
        optionsLegs.current.Legs[legIndex].bidAskMidPoint = bidAskMidPoint;
        optionsLegs.current.Legs[legIndex].gamma = newStrikeDetails.gamma;
        optionsLegs.current.Legs[legIndex].theta = newStrikeDetails.theta;
        optionsLegs.current.Legs[legIndex].vega = newStrikeDetails.vega;

        setFormData(prevValues => ({
          ...prevValues,
          [name]: parseFloat(value),
          [`leg${legIndex + 1}Delta`]: Math.abs(newStrikeDetails.delta * 100).toFixed(0),
          [`leg${legIndex + 1}Quote`]: quote,
        }));

        // Recalculate totals immediately
        recalculateTotals();
      }
    } else if (name.includes("Quantity")) {
      const legIndex = parseInt(name.replace("leg", "").replace("Quantity", "")) - 1;
      let quantity = parseInt(value) || (legIndex === 1 ? 2 : 1);

      // For a butterfly spread:
      // Leg 1 (index 0) = Leg 3 (index 2)
      // Leg 2 (index 1) = 2 × Leg 1 (must be even)

      let leg1Qty, leg2Qty, leg3Qty;

      if (legIndex === 0 || legIndex === 2) {
        // If changing leg 1 or leg 3, they should match
        leg1Qty = quantity;
        leg3Qty = quantity;
        leg2Qty = quantity * 2; // Always even
      } else if (legIndex === 1) {
        // If changing leg 2, round to nearest even number
        leg2Qty = quantity % 2 === 0 ? quantity : quantity + 1;
        leg1Qty = leg2Qty / 2;
        leg3Qty = leg2Qty / 2;
      }

      // Update all three legs
      optionsLegs.current.Legs[0].quantity = leg1Qty;
      optionsLegs.current.Legs[1].quantity = leg2Qty;
      optionsLegs.current.Legs[2].quantity = leg3Qty;

      setFormData(prevValues => ({
        ...prevValues,
        leg1Quantity: leg1Qty,
        leg2Quantity: leg2Qty,
        leg3Quantity: leg3Qty,
      }));

      // Recalculate totals immediately
      recalculateTotals();
    } else {
      setFormData(prevValues => ({
        ...prevValues,
        [name]: value,
      }));
    }
  };

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  const getFieldValueClass = (value, label) => {
    // Max Loss should always be red regardless of value
    if (label === "Max Loss") {
      return "redText";
    }

    // Profit/Loss fields: red if negative, green if positive
    if (label === "Profit/Loss $" || label === "Profit/Loss %") {
      const numValue = parseFloat(value);
      if (numValue < 0) {
        return "redText";
      } else if (numValue > 0) {
        return "greenText";
      }
      return "";
    }

    if (value) {
      if (value.toString().includes("-")) {
        return "redText";
      }
    }
    return "greenText";
  };

  // State for collapsible panels
  const [showRisk, setShowRisk] = useState(true);
  const [showGreeks, setShowGreeks] = useState(true);
  const [showMarket, setShowMarket] = useState(true);

  // Helper to get field value
  const getFieldValue = (label) => {
    const fieldMap = {
      "Security": optionsLegs.current?.["Security"],
      "Last Sale": optionsLegs.current?.["Last Sale"],
      "Expiration": optionsLegs.current?.["Expiration"],
      "Target DTE": optionsLegs.current?.["Target DTE"],
      "Open Cost": optionsLegs.current?.["Open Cost"]?.toFixed(2),
      "Close Cost": optionsLegs.current?.["Close Cost"]?.toFixed(2) || "0.00",
      "Net Amount": optionsLegs.current?.["Net Amount"],
      "Commission & Fee": optionsLegs.current?.["Commission Fee"]?.toFixed(2),
      "Profit/Loss %": optionsLegs.current?.["Profit Loss Percent"]?.toFixed(2) || "0.00",
      "Profit/Loss $": optionsLegs.current?.["Profit Loss Dollars"]?.toFixed(2) || "0.00",
      "Max Gain": optionsLegs.current?.["Max Gain"]?.toFixed(2),
      "Max Loss": optionsLegs.current?.["Max Loss"]?.toFixed(2),
      "Lower Breakeven": optionsLegs.current?.["Lower Breakeven"]?.toFixed(2),
      "Upper Breakeven": optionsLegs.current?.["Upper Breakeven"]?.toFixed(2),
      "Net Delta": optionsLegs.current?.["Net Delta"]?.toFixed(2),
      "Net Gamma": optionsLegs.current?.["Net Gamma"]?.toFixed(2),
      "Net Vega": optionsLegs.current?.["Net Vega"]?.toFixed(2),
      "Net Theta": optionsLegs.current?.["Net Theta"]?.toFixed(2),
      "VIX Price": optionsLegs.current?.["VIX Last Sale"],
      "VIX Change %": optionsLegs.current?.["VIX Change %"],
      "Market Direction": marketSentiment.current?.["overAll"]
    };
    return fieldMap[label] || "N/A";
  };

  // Helper to get field class for coloring
  const getFieldClass = (label) => {
    const value = getFieldValue(label);
    if (label === "Max Loss") return "redText";
    if (label === "Profit/Loss $" || label === "Profit/Loss %") {
      const numValue = parseFloat(value);
      if (numValue < 0) return "redText";
      if (numValue > 0) return "greenText";
      return "";
    }
    if (label === "Market Direction") {
      if (value === "Bullish") return "greenText";
      if (value === "Bearish") return "redText";
      return "";
    }
    if (value && value.toString().includes("-")) return "redText";
    return "greenText";
  };

  const legs = optionsLegs.current?.Legs || [];

  // InfoCard component for top summary cards
  const InfoCard = ({ title, items }) => (
    <div style={{
      flex: '1',
      background: 'rgba(255, 255, 255, 0.95)',
      border: '1px solid rgba(229, 231, 235, 1)',
      borderRadius: '12px',
      padding: '20px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)'
    }}>
      <h3 style={{
        fontSize: '16px',
        fontWeight: '600',
        marginBottom: '16px',
        color: 'rgba(0, 0, 0, 0.9)',
        borderBottom: '2px solid rgba(59, 130, 246, 0.2)',
        paddingBottom: '8px'
      }}>
        {title}
      </h3>
      {items.map((item, index) => (
        <div key={index} style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '8px 0',
          borderBottom: index < items.length - 1 ? '1px solid rgba(0, 0, 0, 0.05)' : 'none'
        }}>
          <span style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: '14px' }}>{item.label}:</span>
          <span className={item.className} style={{ fontWeight: '500', fontSize: '14px' }}>{item.value}</span>
        </div>
      ))}
    </div>
  );

  // CollapsiblePanel component
  const CollapsiblePanel = ({ title, isOpen, toggle, children }) => (
    <div className="landing-panel" style={{ marginBottom: '16px' }}>
      <div
        className="landing-panel-header"
        style={{ cursor: 'pointer', userSelect: 'none' }}
        onClick={toggle}
      >
        <h2 className="landing-panel-title">
          {isOpen ? '▼' : '▶'} {title}
        </h2>
      </div>
      {isOpen && (
        <div className="landing-panel-content">
          {children}
        </div>
      )}
    </div>
  );


  return (
    <AppLayout signOut={signOut}>
      <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '24px' }}>
        {/* Page Title */}
        <div style={{ marginBottom: '24px' }}>
          <h1 style={{ fontSize: '28px', fontWeight: '700', color: 'rgba(0, 0, 0, 0.9)' }}>
            Butterfly Options Analysis
          </h1>
        </div>

        {/* Error and Status Messages */}
        {error && <div className="blink_me_red" style={{ marginBottom: '16px', textAlign: 'center' }}>{error}</div>}
        {displayMessage && <div className="blink_me" style={{ marginBottom: '16px', textAlign: 'center' }}>{displayMessage}</div>}

        {/* Overview Card Row */}
        <div style={{ display: 'flex', gap: '16px', marginBottom: '24px' }}>
          <InfoCard
            title="📊 Position Summary"
            items={[
              { label: 'Security', value: getFieldValue('Security') },
              { label: 'Expiration', value: getFieldValue('Expiration') },
              { label: 'Target DTE', value: getFieldValue('Target DTE') },
              { label: 'Last Sale', value: getFieldValue('Last Sale') }
            ]}
          />
          <InfoCard
            title="💰 Pricing & Costs"
            items={[
              { label: 'Net Amount', value: getFieldValue('Net Amount'), className: getFieldClass('Net Amount') },
              { label: 'Commission & Fee', value: getFieldValue('Commission & Fee') },
              { label: 'Open Cost', value: getFieldValue('Open Cost'), className: getFieldClass('Open Cost') },
              { label: 'Close Cost', value: getFieldValue('Close Cost'), className: getFieldClass('Close Cost') }
            ]}
          />
          <InfoCard
            title="📈 P/L Snapshot"
            items={[
              { label: 'Profit/Loss $', value: getFieldValue('Profit/Loss $'), className: getFieldClass('Profit/Loss $') },
              { label: 'Profit/Loss %', value: getFieldValue('Profit/Loss %') + '%', className: getFieldClass('Profit/Loss %') },
              { label: 'Max Gain', value: getFieldValue('Max Gain'), className: getFieldClass('Max Gain') },
              { label: 'Max Loss', value: getFieldValue('Max Loss'), className: getFieldClass('Max Loss') }
            ]}
          />
        </div>

        {/* Strategy Legs Setup Section */}
        <div className="landing-panel" style={{ marginBottom: '24px' }}>
          <div className="landing-panel-header">
            <h2 className="landing-panel-title">⚙️ Strategy Legs Setup</h2>
          </div>
          <div className="landing-panel-content">
            <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
              {legs.map((leg, index) => {
                const strikes = leg.type === "call" ? callStrikes.current : putStrikes.current;
                // Use green background for Buy (legs 1 and 3), red for Sell (leg 2)
                const backgroundColor = leg.action === "Buy" ? 'rgba(240, 253, 244, 1)' : 'rgba(254, 242, 242, 1)';

                return (
                  <div key={index} style={{
                    display: 'grid',
                    gridTemplateColumns: '180px 1fr 70px 100px 70px 100px 70px 100px',
                    gap: '12px',
                    alignItems: 'center',
                    marginBottom: '12px',
                    padding: '12px',
                    background: backgroundColor,
                    borderRadius: '8px'
                  }}>
                    <label style={{ fontWeight: '600', color: 'rgba(0, 0, 0, 0.8)' }}>
                      {leg.label} ({leg.action}):
                    </label>
                    <select
                      name={`leg${index + 1}Strike`}
                      value={formData[`leg${index + 1}Strike`] || leg.strike}
                      onChange={handleChange}
                      style={{
                        padding: '8px 12px',
                        border: '1px solid rgba(209, 213, 219, 1)',
                        borderRadius: '6px',
                        fontSize: '14px'
                      }}
                    >
                      {strikes.map(price => (
                        <option key={price} value={price}>{price}</option>
                      ))}
                    </select>
                    <label style={{ fontWeight: '500', color: 'rgba(0, 0, 0, 0.7)' }}>Delta:</label>
                    <input
                      type="text"
                      name={`leg${index + 1}Delta`}
                      value={formData[`leg${index + 1}Delta`] || Math.abs(leg.actualDelta * 100).toFixed(0)}
                      readOnly
                      style={{
                        padding: '8px 12px',
                        border: '1px solid rgba(209, 213, 219, 1)',
                        borderRadius: '6px',
                        fontSize: '14px',
                        background: 'rgba(243, 244, 246, 1)'
                      }}
                    />
                    <label style={{ fontWeight: '500', color: 'rgba(0, 0, 0, 0.7)' }}>Quote:</label>
                    <input
                      type="text"
                      name={`leg${index + 1}Quote`}
                      value={
                              formData[`leg${index + 1}Quote`] != null && formData[`leg${index + 1}Quote`] !== ''
                                ? Number(formData[`leg${index + 1}Quote`]).toFixed(2)
                                : (leg.quote != null ? Number(leg.quote).toFixed(2) : '')
                            }
                      readOnly
                      style={{
                        padding: '8px 12px',
                        border: '1px solid rgba(209, 213, 219, 1)',
                        borderRadius: '6px',
                        fontSize: '14px',
                        background: 'rgba(243, 244, 246, 1)'
                      }}
                    />
                    <label style={{ fontWeight: '500', color: 'rgba(0, 0, 0, 0.7)' }}>Qty:</label>
                    <input
                      type="number"
                      name={`leg${index + 1}Quantity`}
                      value={formData[`leg${index + 1}Quantity`] || leg.quantity}
                      onChange={handleChange}
                      min={index === 1 ? "2" : "1"}
                      step={index === 1 ? "2" : "1"}
                      style={{
                        padding: '8px 12px',
                        border: '1px solid rgba(209, 213, 219, 1)',
                        borderRadius: '6px',
                        fontSize: '14px'
                      }}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Collapsible Panels */}
        <CollapsiblePanel
          title="🎯 Risk Levels"
          isOpen={showRisk}
          toggle={() => setShowRisk(!showRisk)}
        >
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
            <div style={{ padding: '12px', background: 'rgba(249, 250, 251, 1)', borderRadius: '8px' }}>
              <div style={{ fontWeight: '600', marginBottom: '8px', color: 'rgba(0, 0, 0, 0.8)' }}>Upper Breakeven:</div>
              <div className={getFieldClass('Upper Breakeven')} style={{ fontSize: '18px', fontWeight: '500' }}>
                {getFieldValue('Upper Breakeven')}
              </div>
            </div>
            <div style={{ padding: '12px', background: 'rgba(249, 250, 251, 1)', borderRadius: '8px' }}>
              <div style={{ fontWeight: '600', marginBottom: '8px', color: 'rgba(0, 0, 0, 0.8)' }}>Lower Breakeven:</div>
              <div className={getFieldClass('Lower Breakeven')} style={{ fontSize: '18px', fontWeight: '500' }}>
                {getFieldValue('Lower Breakeven')}
              </div>
            </div>
          </div>
        </CollapsiblePanel>

        <CollapsiblePanel
          title="📊 Greeks (Position Sensitivities)"
          isOpen={showGreeks}
          toggle={() => setShowGreeks(!showGreeks)}
        >
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '16px' }}>
            <div style={{ padding: '12px', background: 'rgba(249, 250, 251, 1)', borderRadius: '8px' }}>
              <div style={{ fontWeight: '600', marginBottom: '8px', color: 'rgba(0, 0, 0, 0.8)', fontSize: '12px' }}>Net Delta</div>
              <div style={{ fontSize: '16px', fontWeight: '500' }}>{getFieldValue('Net Delta')}</div>
            </div>
            <div style={{ padding: '12px', background: 'rgba(249, 250, 251, 1)', borderRadius: '8px' }}>
              <div style={{ fontWeight: '600', marginBottom: '8px', color: 'rgba(0, 0, 0, 0.8)', fontSize: '12px' }}>Net Gamma</div>
              <div style={{ fontSize: '16px', fontWeight: '500' }}>{getFieldValue('Net Gamma')}</div>
            </div>
            <div style={{ padding: '12px', background: 'rgba(249, 250, 251, 1)', borderRadius: '8px' }}>
              <div style={{ fontWeight: '600', marginBottom: '8px', color: 'rgba(0, 0, 0, 0.8)', fontSize: '12px' }}>Net Vega</div>
              <div style={{ fontSize: '16px', fontWeight: '500' }}>{getFieldValue('Net Vega')}</div>
            </div>
            <div style={{ padding: '12px', background: 'rgba(249, 250, 251, 1)', borderRadius: '8px' }}>
              <div style={{ fontWeight: '600', marginBottom: '8px', color: 'rgba(0, 0, 0, 0.8)', fontSize: '12px' }}>Net Theta</div>
              <div style={{ fontSize: '16px', fontWeight: '500' }}>{getFieldValue('Net Theta')}</div>
            </div>
          </div>
        </CollapsiblePanel>

        <CollapsiblePanel
          title="🌍 Market Context"
          isOpen={showMarket}
          toggle={() => setShowMarket(!showMarket)}
        >
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px' }}>
            <div style={{ padding: '12px', background: 'rgba(249, 250, 251, 1)', borderRadius: '8px' }}>
              <div style={{ fontWeight: '600', marginBottom: '8px', color: 'rgba(0, 0, 0, 0.8)' }}>VIX Price:</div>
              <div style={{ fontSize: '18px', fontWeight: '500' }}>{getFieldValue('VIX Price')}</div>
            </div>
            <div style={{ padding: '12px', background: 'rgba(249, 250, 251, 1)', borderRadius: '8px' }}>
              <div style={{ fontWeight: '600', marginBottom: '8px', color: 'rgba(0, 0, 0, 0.8)' }}>VIX Change %:</div>
              <div className={getFieldClass('VIX Change %')} style={{ fontSize: '18px', fontWeight: '500' }}>
                {getFieldValue('VIX Change %')}
              </div>
            </div>
            <div
              style={{ padding: '12px', background: 'rgba(249, 250, 251, 1)', borderRadius: '8px' }}
              title={marketSentiment.current ? `High
-----
  Greeks - ${marketSentiment.current["greeks"]}

Medium - High
---------------
  Strike Proximity - ${marketSentiment.current["strikeProximity"]}
  Options Delta Distribution - ${marketSentiment.current["optionDeltaDistribution"]}
  Implied Volatility - ${marketSentiment.current["iv"]}

Medium - Low
--------------
  Bid Ask Spread - ${marketSentiment.current["bidAskSpread"]}

Low
----
  Open Interest - ${marketSentiment.current["openInterest"]}
  Put Call Ratio - ${marketSentiment.current["pcr"]}
  Skewness Strike Prices - ${marketSentiment.current["skewnessStrikePrices"]}` : ''}
            >
              <div style={{ fontWeight: '600', marginBottom: '8px', color: 'rgba(0, 0, 0, 0.8)' }}>Market Direction:</div>
              <div className={getFieldClass('Market Direction')} style={{ fontSize: '18px', fontWeight: '500' }}>
                {getFieldValue('Market Direction') || 'N/A'}
              </div>
            </div>
          </div>
        </CollapsiblePanel>

        {/* Action Buttons */}
        <div style={{
          display: 'flex',
          gap: '12px',
          justifyContent: 'center',
          marginTop: '24px'
        }}>
          <button
            onClick={() => { handleSave(); }}
            style={{
              padding: '12px 32px',
              background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            Save
          </button>
          <button
            onClick={() => { setInput("/myPortfolioButterfly"); }}
            style={{
              padding: '12px 32px',
              background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(59, 130, 246, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            Butterfly Portfolio
          </button>
        </div>
      </div>
    </AppLayout>
  );
}

export default ButterflyOptionsLegs;
